import { Box, Button, Center, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FC, useEffect, useState } from "react";
import MemberService from "../../../services/members/member-service";
import LogosNotification from "../../../utils/notification-utils";

interface ChangeMemberDetailProps {
    member: any,
    onClose: any
};


const ChangeMemberDetail: FC<ChangeMemberDetailProps> = ({ member, onClose }) => {
    const [formValue, setFormValue] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>([]);

    useEffect(() => {
        setFormValue({
            email: member.emailAddress,
            newEmail: member.emailAddress,
            phone: member.phoneNumber
        });
        setIsLoading(false);
    }, []);

    const handleFormSubmit = (values: any) => {
        setErrors([]);
        setIsSubmiting(true);

        MemberService.ChangeAccountDetail(member.id, values.newEmail, values.phone)
            .then((res: any) => {
                LogosNotification.Success("Informasi Member berhasil diperbaharui.");
                setTimeout(() => window.location.reload(), 2000);
            }).catch((error) => {
                if (typeof error.response.data.result.errors === "object") {
                    let errorMessages: any = [];
                    const ObjectKey = Object.keys(error.response.data.result.errors);
                    ObjectKey.map((item) => {
                        error.response.data.result.errors[item].map((message: any) => {
                            errorMessages.push(`${message}`);
                        })
                    });
                    setErrors(errorMessages);
                }
            }).finally(() => {
                setIsSubmiting(false);
            });
    };

    if (isLoading)
        return <></>;

    return (
        <Modal isOpen={true} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                    {
                        ({ handleSubmit, errors, touched, setFieldValue }) => (
                            <Form onSubmit={handleSubmit} noValidate={true}>
                                <ModalHeader textAlign={"center"}>Change Account Detail</ModalHeader>
                                <ModalBody pt={5}>
                                    <FormControl mt={4}>
                                        <FormLabel>Email</FormLabel>
                                        <Field
                                            as={Input}
                                            id='email'
                                            placeholder='Email'
                                            name={'email'}
                                            disabled={true}
                                        />
                                        <FormErrorMessage>{errors.email}</FormErrorMessage>
                                    </FormControl>

                                    <FormControl isRequired isInvalid={!!(errors.newEmail && touched.newEmail)} mt={4}>
                                        <FormLabel>Email Baru</FormLabel>
                                        <Field
                                            as={Input}
                                            id='newEmail'
                                            placeholder='Email Baru'
                                            name={'newEmail'}
                                            autoComplete={false}
                                            validate={(value: any) => {
                                                let error;
                                                if (value.length <= 0)
                                                    error = "Email Baru wajib diisi.";
                                                return error;
                                            }}
                                        />
                                        <FormErrorMessage>{errors.newEmail}</FormErrorMessage>
                                    </FormControl>

                                    <FormControl isRequired isInvalid={!!(errors.phone && touched.phone)} mt={4}>
                                        <FormLabel>No Whatsapp</FormLabel>
                                        <Field
                                            as={Input}
                                            id='phone'
                                            placeholder='No. Whatsapp'
                                            name={'phone'}
                                            validate={(value: any) => {
                                                let error;
                                                if (value.length <= 0)
                                                    error = "Nomor Whatsapp wajib diisi.";
                                                return error;
                                            }}
                                        />
                                        <FormErrorMessage>{errors.phone}</FormErrorMessage>
                                    </FormControl>
                                </ModalBody>

                                <ModalFooter>
                                    <Button variant={'outline'} mr={3} onClick={onClose}>
                                        Close
                                    </Button>
                                    <Button type={'submit'} isLoading={isSubmiting}>Submit</Button>
                                </ModalFooter>
                            </Form>
                        )
                    }
                </Formik>

                {
                    <Box mt={4}>
                        {
                            errors.length > 0 && errors.map((error: any) => {
                                return (
                                    <Text color={'red'}>{error}</Text>
                                );
                            })
                        }
                    </Box>
                }
            </ModalContent>
        </Modal>
    );
};

export default ChangeMemberDetail;